import styled from "styled-components";

export const StarContainer = styled.div`
  font-size: 24px;
  color: #ccc;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Star = styled.span`
  margin: 0.25rem;
`;